<button
  #closeButton
  type="button"
  (click)="closeModalHandler()"
  [ngClass]="layoutMode"
  tabindex="-1">
  <mat-icon>close</mat-icon>
</button>
